import * as React from "react";

import { Field, FieldLabel, ValidationError } from "affinityUI/form/components";
import { Select } from "affinityUI/form/inputs/select";

import { useAffinityField } from "../../helpers";

export const SelectField: React.FC<
  React.ComponentProps<typeof Select> & { options: Array<{ value: string; label: string }> }
> = ({ children, options, ...props }) => {
  const { name } = props;
  const [fieldData, meta] = useAffinityField(name);
  const field = { ...fieldData, value: fieldData.value ?? "" };
  const optionsList = options.map(({ label, value }) => (
    <option value={value} key={`${label}-${value}`}>
      {label}
    </option>
  ));
  return (
    <Field>
      <FieldLabel id={`field-${name}`} htmlFor={name}>
        {children}
      </FieldLabel>
      <Select id={name} $error={meta?.error} {...field} {...props}>
        <>{optionsList}</>
      </Select>
      {meta?.error && <ValidationError>{meta?.error}</ValidationError>}
    </Field>
  );
};
